/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  $(window).scroll(function(){

    var wScroll = $(this).scrollTop();

    $('.dots').css({
      'transform' : 'translate(0px, '+ wScroll /7 +'%)'
    });
  });


  $(function() {
      $('.three-boxes-home .right-section').matchHeight({
          target: $('.three-boxes-home .left-section')
      });
  });

  $(function() {
    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);

    $('.modal').on('hidden.bs.modal', function () {
      player.pause();
    })

    $('.modal').on('shown.bs.modal', function () {
      player.play();
    })
  });


  $('.clients-logos-slider').owlCarousel({
      margin:10,
      nav:true,
      loop:true,
      dots:true,
      autoplay:true,
      autoplayTimeout:10000,
      autoplayHoverPause:false,
      responsiveClass:true,
      responsive:{
          0:{
              items:3,
              nav:true,
              dots:true,
              slideBy: 6,              
              scrollPerPage: true,
          },
          600:{
              items:4,
              nav:true,
              dots:true,
              slideBy: 6,
              scrollPerPage: true,
          },
          1000:{
              items:6,
              nav:true,
              dots:true,
              slideBy: 6,
              scrollPerPage: true,
          }
      }
  });

  // $('.blog-carousel').owlCarousel({
  //     loop:false,
  //     margin:30,
  //     nav:true,
  //     dots:true,
  //     responsiveClass:true,
  //     responsive:{
  //         0:{
  //             items:1,
  //             nav:false,
  //             dots:true,
  //         },
  //         600:{
  //             items:2,
  //             nav:false,
  //             dots:true,
  //         },
  //         1000:{
  //             items:3,
  //             nav:false,
  //             dots:true,
  //         }
  //     }
  // });

  $('.testimonials-carousel').owlCarousel({
      loop:false,
      margin:30,
      nav:true,
      dots:true,
      responsiveClass:true,
      responsive:{
          0:{
              items:1,
              nav:false,
              dots:true,
          },
          600:{
              items:1,
              nav:false,
              dots:true,
          },
          1000:{
              items:2,
              nav:false,
              dots:true,
          }
      }
  });

  $('.aerial-filming-slideshow').owlCarousel({
      loop:false,
      nav:true,
      dots:true,
      responsiveClass:true,
      responsive:{
          0:{
              items:1,
              nav:true,
              dots:true,
              loop:true,
              stagePadding: 60,
          },
          300:{
              loop:true,
              items:1,
              nav:true,
              dots:true,
              stagePadding: 60,
          },
          700:{
              items:3,
              nav:true,
              dots:true,
          }
      }
  });

  $(".play-showreel").modalVideo({channel:'vimeo'});

  $(".play-youtube").modalVideo({channel:'youtube'});

  $(".about-video .video img").modalVideo({channel:'vimeo'});


  $('[data-toggle="dropdown"]').on('click', function() {
      setTimeout(function() {
        $(window).trigger('resize');
        console.log('huoh');
      }, 50);
  });

})(jQuery); // Fully reference jQuery after this point.
